import { msg } from '@lingui/core/macro';

export const WELCOME_PAGE_TITLE_TEXT = msg`An exciting update!`;

export const WELCOME_HEADING = msg`We've got exciting news!`;

export const WELCOME_PARAGRAPH_1 = msg`Cat in a Flat is now part of the Rover Group, the world's largest network of 5-star pet sitters and dog walkers.`;

export const WELCOME_PARAGRAPH_2 = msg`What this means for you: a larger community of pet people, new service offerings, industry leading technology, and even more purrs for your furry family members.`;

export const WELCOME_PARAGRAPH_3 = msg`Stay tuned for more details! In the meantime, you can learn more about the upcoming changes in the FAQ below.`;
